/* eslint-disable @typescript-eslint/no-empty-function */
import { Box, Container, Typography } from '@mui/material';
import { User } from 'oidc-client';
import React, { useEffect, useMemo } from 'react';
import { UserData } from 'react-oidc';
import { Route, Switch } from 'react-router-dom';
import { win } from '../utilities/window';
import { BffSessionUser, bffLoginUrl, currentUrl } from './bff-session';
import { FkoErrorPage } from './fko-error-page';
import { LoggedOut } from './logged-out';
import { Login } from './login';

export interface BffSessionWrapperProps {
  children: JSX.Element;
  renderError: () => JSX.Element;
  user: BffSessionUser | undefined;
}

// useAuthenticatedUser() reads the user from react-oidc's context, so the ~90 places that use it work in both modes
function userDataOf(user: BffSessionUser) {
  return {
    signOut: () => {},
    user: { profile: { id: user.id, sub: user.sub, name: user.name } } as unknown as User,
    userManager: null,
  };
}

function GoToBffLogin() {
  useEffect(() => {
    win.location.assign(bffLoginUrl(currentUrl()));
  }, []);

  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
        <Typography variant="body1">Sender dig videre til login...</Typography>
      </Box>
    </Container>
  );
}

/** The routes of the jobcenter desktop when the BFF holds the login, and the caseworker is known from its session. */
export function BffSessionWrapper(props: BffSessionWrapperProps) {
  const { children, renderError, user } = props;
  const userData = useMemo(() => user && userDataOf(user), [user]);

  return (
    <Switch>
      <Route path="/error" render={renderError} />
      <Route path="/fko-error-page">
        <FkoErrorPage />
      </Route>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/logged-out">
        <LoggedOut />
      </Route>
      <Route path="/">{userData ? <UserData.Provider value={userData}>{children}</UserData.Provider> : <GoToBffLogin />}</Route>
    </Switch>
  );
}
